module.exports = __webpack_public_path__ + "static/media/aktivation_loading.5b6ccd03.gif";